import React, {useEffect} from 'react' 
import Aos from 'aos';
import "aos/dist/aos.css";

import { Link } from 'react-router-dom'
import {FacebookIcon, InstagramIcon, LinkedinIcon } from '../../../Shared/Images/image';

const ContactAddress = props => {
    useEffect(()=>{
        Aos.init({duration: 2000})
    }, []) 
     return(
        <div className="col-md-5" data-aos="fade-left">
            <div className="pl-md-2">
                <div className="contactus-address">
                    <h6 className="heading6 text-color2 fw-sb">HR Pvt Ltd</h6>
                    <h6 className="heading6 text-color2 fw-sb">Office Number 32, 3rd floor</h6>
                    <h6 className="heading6 text-color2 fw-sb">Opposite Jamia Ashrafia</h6>
                    <h6 className="heading6 text-color2 fw-sb">Ferozpur Road Lahore</h6>
                    <h6 className="heading6 text-color2 fw-sb">+92-323-8882012</h6>
                    <h6 className="heading6 text-color2 fw-sb">hr@hr.org</h6>
                </div>

                <div>
                    <ul className="list-unstyled footer-social-links">
                        <li><Link to=""><img src={FacebookIcon} alt="facebook" /></Link></li>
                        <li><Link to=""><img src={InstagramIcon} alt="instagram" /></Link></li>
                        <li><Link to=""><img src={LinkedinIcon} alt="linkedin" /></Link></li>
                    </ul>
                </div>
            </div>  
        </div>
     )
}
export default ContactAddress;